import { useQuery } from '@tanstack/react-query';

import { useAuthState } from '@creditornot/wolt-auth/react';
import { UseQueryConfig } from 'common/query/types';

import { gatewayApiAgent } from '../api/apiAgents';
import { ListMetaVenues } from '../api-types/director';
import { FetchListItemsParams } from '../types';

type FetchVenuesParams = FetchListItemsParams & { franchise?: string };

export const VENUES_QUERY_KEY_ROOT = 'venues';

const pageDefaults = { pageSize: 1000, page: 0 };
const fetchVenues = (params?: FetchVenuesParams): Promise<ListMetaVenues> =>
  gatewayApiAgent
    .get('/director/public/v1/venues', { params: { ...pageDefaults, ...params } })
    .then((res) => res.data);

export const useVenuesQuery = (
  params: FetchVenuesParams = {},
  options?: UseQueryConfig<ListMetaVenues, Error>,
) => {
  const { status } = useAuthState();

  return useQuery({
    staleTime: 300000,
    enabled: status === 'logged-in',
    placeholderData: (previousData) => previousData,
    ...options,
    queryKey: [VENUES_QUERY_KEY_ROOT, params],
    queryFn: () => fetchVenues(params),
  });
};
